import { Link } from 'react-router-dom';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import Box from '@mui/material/Box';

const CustomLink = ({ to, linkText, disabled }) => {
    return (
        <Box sx={{ 
                borderRadius: '10px', 
                padding: '1rem', 
                width: { xs: '100%', sm: '25rem' }, 
                margin: 'auto',
                mb: 2,
                fontSize: { xs: '1rem', sm: '1.2rem' }, 
                fontWeight: '600',
                background: 'linear-gradient(0.25turn, rgb(91, 59, 140), rgb(118, 93, 160), rgb(118, 093, 160))',
                color: '#fff',
                textAlign: 'center',
                ...(disabled ? {} : {
                  '&:hover': {
                    boxShadow: '0px 4px 20px rgba(81, 80, 82, 0.8)',
                    transform: 'scale(1.03)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  }
                })
            }}>
            <Link style={{ color: '#fff', pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.5 : 1 }} to={to}>
                {linkText}
                <DoubleArrowIcon sx={{ verticalAlign: "middle", color: '#fff', fontSize: "large" }} />
            </Link>
        </Box>
    )
}

export default CustomLink;